import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { getPackagesList } from "../../services/packagesApi";
import { redirectToSubscription } from "../../utils/premiumCheck";
import { usePackagesModal } from "../../context/PackagesModalContext";
import "./PackagesModal.css";

const PackagesModal = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { hidePackages } = usePackagesModal();

  useEffect(() => {
    fetchPackages();
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await getPackagesList();
      if (response?.success && response?.data?.data) {
        const activePackages = response.data.data
          .filter((pkg) => pkg.packageId?.status === true)
          .sort((a, b) => a.positionPakcage - b.positionPakcage);
        setPackages(activePackages);
      } else {
        setError("خطا در دریافت لیست پکیج‌ها");
      }
    } catch (err) {
      setError("خطا در ارتباط با سرور");
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price) => {
    const toman = price / 10;
    if (price < 10000000) {
      return `${(toman / 1000).toFixed(0)} هزار تومان`;
    }
    const million = toman / 1000000;
    const formatted = million % 1 === 0 ? million.toFixed(0) : million.toFixed(1);
    return `${formatted} میلیون تومان`;
  };

  const handleSelectPackage = (pkg) => {
    hidePackages();
    redirectToSubscription();
  };

  const modalContent = (
    <div className="packages-modal-overlay" onClick={hidePackages}>
      <div className="packages-modal" onClick={(e) => e.stopPropagation()}>
        <div className="packages-modal-header">
          <h3>خرید اشتراک ویژه</h3>
          <button className="packages-modal-close" onClick={hidePackages}>
            ✕
          </button>
        </div>

        <div className="packages-modal-body">
          <p className="packages-modal-desc">
            برای دسترسی به این ویژگی، یکی از پکیج‌های اشتراک ویژه را تهیه کنید.
          </p>

          {loading && (
            <div className="packages-loading">
              <div className="spinner"></div>
              <p>در حال دریافت لیست پکیج‌ها...</p>
            </div>
          )}

          {error && (
            <div className="packages-error">
              <p>{error}</p>
              <button className="btn ghost small" onClick={fetchPackages}>
                تلاش مجدد
              </button>
            </div>
          )}

          {!loading && !error && packages.length === 0 && (
            <div className="packages-empty">
              <p>پکیجی برای نمایش وجود ندارد</p>
            </div>
          )}

          {!loading && !error && packages.length > 0 && (
            <div className="packages-grid">
              {packages.map((pkg) => (
                <div
                  key={pkg.packageId._id}
                  className={`package-card ${pkg.typeOfPackage === "popular" ? "popular" : ""}`}
                >
                  {pkg.typeOfPackage === "popular" && (
                    <div className="popular-badge">
                      {pkg.subDisplayName || "پرفروش‌ترین"}
                    </div>
                  )}

                  <div className="package-card-title">
                    {pkg.packageId.displayName}
                  </div>

                  <div className="package-card-duration">
                    {pkg.packageId.validityDuration} روز
                  </div>

                  <div className="package-card-price">
                    {pkg.packageId.discountPercent > 0 && (
                      <>
                        <span className="old-price">
                          {formatPrice(pkg.packageId.realPrice)}
                        </span>
                        <span className="discount-badge">
                          -{pkg.packageId.discountPercent}%
                        </span>
                      </>
                    )}
                    <div className="final-price">
                      {formatPrice(pkg.packageId.price)}
                    </div>
                  </div>

                  <div className="package-card-features">
                    {pkg.packageId.features?.map((feature, idx) => (
                      <div key={idx} className="feature-item">
                        {feature}
                      </div>
                    ))}
                  </div>

                  <button
                    className="btn purchase-btn"
                    onClick={() => handleSelectPackage(pkg)}
                  >
                    {pkg.buttonText || "خرید اشتراک"}
                  </button>
                </div>
              ))}
            </div>
          )}

          <div className="packages-modal-footer">
            <button className="btn ghost" onClick={hidePackages}>
              بعداً اقدام میکنم
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default PackagesModal;
